const set_language = 'setLanguage';
const set_loading = 'setLoading';

export { set_language, set_loading };
